<div class="bd-example">
    <it-header slimTitle="{{getValore('comune')}}" slimTitleLink="" [light]="light" [showSearch]="search"
        [sticky]="sticky" [megamenu]="true">

        <ul class="link-list" slimLinkList>
            <li>
                <a href="/notifiche">Notifiche
                    <span class="badge text-bg-secondary ms-2 badge-notifica">{{numeroNotificheNonLette}}</span>
                </a>
            </li>
            <li class="d-flex align-items-center">
                <a routerLink="/mio-profilo" class="text-decoration-none">{{getUtente()}}</a>
            </li>
            <li>
                <a (click)="logout()" class="d-flex align-items-center pointer">
                    <it-icon name="logout" class="me-1"></it-icon> Esci
                </a>
            </li>
        </ul>

        <ng-container slimRightZone>
        </ng-container>

        <ng-container brand>
            <a href="/home">
                <it-icon name="pa"></it-icon>
                <div class="it-brand-text ">
                    <div class="it-brand-title">SI-COT</div>
                    <div class="it-brand-tagline d-none d-md-block">Progetto COT Puglia</div>
                </div>
            </a>
            <div class="pb-2"></div>
        </ng-container>

    </it-header>
</div>